import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router";
import {
	Modal,
	Button,
	Pager
} from "rhombus-react";

import { Submission } from "reducers/QASubmission";
import ApprovalGrid from "./ApprovalGrid";
import { useCollectionFiltering } from "utils/DataGrid";

import { APPROVAL_COLUMNS } from "widgets/grid/columns/ApprovalColumns";
import { QA_ROW_COUNT_OPTIONS } from "utils/constants";

import "./ApprovalModal.css";

export default function ApprovalModal(){
	const dispatch = useDispatch();
	const submission = useSelector(state => state.qaSubmission);

	const { libraryId } = useParams()
		, history = useHistory()
		;

	const {
		filterInfo: { page, rpp, sort },
	} = useCollectionFiltering(
		submission,
		Submission.setAdvancedFilter,
		() => {
			dispatch(Submission.clearList())
				.then(() => {
					dispatch(Submission.loadSubmissionList(libraryId));
				});
		}
	);

	useEffect(() => {
		dispatch(Submission.resetAllFilters());
	}, [libraryId]);

	const pagerProps = {
		showItemCount: true,
		initialPage: page,
		forcePage: page,
		pageSize: rpp,
		pageCount: submission.totalPages,
		maxItems: submission.totalItems,
		showItemWord: "",
		rowCountItems: QA_ROW_COUNT_OPTIONS,

		disabled: !submission.isLoaded,

		onPageChange: newPage => dispatch(Submission.setPage(newPage)),
		onRowCountChange: newRPP => dispatch(Submission.setRPP(newRPP)),
	};

	function Content(){
		return (
			<div className="qa-submission-modal-content">
				<div className="grid">
					<ApprovalGrid
						items = {submission.items}
						isLoading={!submission.isLoaded}
						sort={sort}
						columns = {APPROVAL_COLUMNS}
						resetScroll = {false}
					/>
				</div>
				<Pager {...pagerProps} />
			</div>
		);
	}

	function closeModal(){
		history.replace("/qa-panel/");
		dispatch(Submission.resetAllFilters());
	}

	function Footer(){
		return (
			<Button
				theme="default"
				onClick={closeModal}>
				Close
			</Button>
		);
	}

	let modalProps = {
		type:"modal",
		allowFullScreen: false,
		bladeProps: {
			verticallyCenter: true,
		},
		onClose: closeModal,
		setAppTitle: false,
		title:"Approval History",
		xClose: true,
		className: `qa-submission-modal`,
		renderContent: Content,
		renderFooter: Footer,
	};

	return <Modal {...modalProps} />;
}

ApprovalModal.displayName = "ApprovalModal";
